/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./client/app/scripts/components/full-width-get-started-button.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./client/app/scripts/components/full-width-get-started-button.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _addPassiveEventListener = __webpack_require__("./client/app/scripts/principles/addPassiveEventListener.js");

var _addPassiveEventListener2 = _interopRequireDefault(_addPassiveEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (document.querySelector('.lead-constructor__panel--welcome')) {
  $('.edge-button--info-prices').addClass('js-get-started');
}

(0, _addPassiveEventListener2.default)(window, 'scroll', function () {
  if (document.querySelector('.lead-constructor__panel--welcome')) {
    document.querySelector('.edge-button--info-prices').classList.add('edge-button--info-prices--scrolled');
  }
});

$('.js-get-started').on('click', function (e) {
  e.preventDefault();
  if ($('.js-leadform--wizard').hasClass('interacted')) {
    $('html, body').animate({ scrollTop: 0 }, 400);
  } else {
    $('.lead-constructor__panel--welcome .js-lead-constructor__next').click();
  }
});

$('.js-leadform--wizard').on('click', ['.js-lead-constructor__next', '.js-lead-constructor__back'], function () {
  $('html, body').animate({ scrollTop: 0 }, 400);
});

/***/ }),

/***/ "./client/app/scripts/principles/addPassiveEventListener.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (el, type, callback) {
  el.addEventListener(type, callback, passiveSupported ? { passive: true } : false);
};

var passiveSupported = false;

try {
  var options = {
    get passive() {
      passiveSupported = true;
      return false;
    }
  };

  window.addEventListener('test', null, options);
  window.removeEventListener('test', null, options);
} catch (err) {
  passiveSupported = false;
}

/***/ })

/******/ });


// WEBPACK FOOTER //
// full-width-get-started-button.js